import { Skeleton } from "antd";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function GeneralInformation({ data, loading }: Props) {
  // const presentAddress = data?.presentAddress
  //   ? `${data.presentAddress.union}, ${data.presentAddress.upazila}, ${data.presentAddress.district}, ${data.presentAddress.division}`
  //   : "N/A";

  // const permanentAddress = data?.permanentAddress
  //   ? `${data.permanentAddress.union}, ${data.permanentAddress.upazila}, ${data.permanentAddress.district}, ${data.permanentAddress.division}`
  //   : "N/A";

  const formatDate = (dateString?: string | null) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US");
  };

  return (
    <Section title="সাধারণ তথ্য" type="general">
      <Info
        label="আপনার পূর্ণ নাম (ইংরেজী)"
        value={
          loading ? <Skeleton.Input active size="small" /> : data?.fullName
        }
      />
      <Info
        label="পিতার নাম (ইংরেজী)"
        value={
          loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            data?.fatherName || "N/A"
          )
        }
      />
      <Info
        label="মাতার নাম (ইংরেজী)"
        value={
          loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            data?.motherName || "N/A"
          )
        }
      />
      <Info
        label="জন্ম তারিখ"
        value={
          loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            formatDate(data?.dateOfBirth)
          )
        }
      />
      {/* <Info
        label="স্থায়ী ঠিকানা"
        value={
          loading ? <Skeleton.Input active size="small" /> : permanentAddress
        }
      />
      <Info
        label="বর্তমান ঠিকানা"
        value={
          loading ? <Skeleton.Input active size="small" /> : presentAddress
        }
      /> */}
      <Info
        label="মোবাইল নম্বর"
        value={loading ? <Skeleton.Input active size="small" /> : data?.phone}
      />
      <Info
        label="ইমেইল"
        value={loading ? <Skeleton.Input active size="small" /> : data?.email}
      />
    </Section>
  );
}
